import { Empty, Listy, Spin, type ListyClassNames, type ListyProps } from 'antd';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import { LISTY_ITEM_NO_HOVER } from '../listyItemClassNames';

export type ListyWithEmptyProps<T> = {
  items: T[];
  emptyText: ReactNode;
  loading?: boolean;
  rowKey: ListyProps<T>['rowKey'];
  itemRender: ListyProps<T>['itemRender'];
  className?: string;
  classNames?: ListyClassNames;
};

/** Empty / Spin / Listy switch matching SharePointPerimeterPicker. */
export default function ListyWithEmpty<T>({
  items,
  emptyText,
  loading = false,
  rowKey,
  itemRender,
  className,
  classNames,
}: ListyWithEmptyProps<T>) {
  if (loading) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center">
        <Spin />
      </div>
    );
  }

  if (items.length === 0) {
    return <Empty description={emptyText} />;
  }

  return (
    <Listy
      items={items}
      rowKey={rowKey}
      itemRender={itemRender}
      className={className}
      classNames={{
        ...classNames,
        item: clsx(LISTY_ITEM_NO_HOVER, classNames?.item),
      }}
    />
  );
}
